import React from "react";
import { Box, Typography } from "@mui/material";

const ImageOverlayButton = ({
  text,
  fontSize,
  textColor,
  width = 150,
  borderColor = "rgba(255, 255, 255, 0.4)",
  sx = {}, // Accept custom sx props
}) => {
  return (
    <Box
      display="flex"
      justifyContent="center"
      mb={2}
      sx={{
        width,
        borderRadius: 99,
        backdropFilter: "blur(32px)",
        border: "1px solid",
        borderColor: borderColor,
        cursor: "pointer",
        ...sx, // Merge custom sx props
      }}
    >
      <Typography
        p={0.8}
        textAlign="center"
        fontSize={fontSize}
        fontWeight={700}
        sx={{ color: textColor }}
      >
        {text}
      </Typography>
    </Box>
  );
};

export default ImageOverlayButton;
